export default __webpack_public_path__ + "static/media/prize-2.ec7d03d0.webp";